import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["use"];
import { Button } from 'foundations-components/transitional/components/Button';
import AbstractRouterLink from './internal/AbstractRouterLink';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * A [`Button`](https://private.hubteamqa.com/foundations-components-storybook/?path=/docs/transitional-button--basic)
 * type component with router support.
 */
export default function RouterButton(props) {
  const {
      use = 'tertiary-light'
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(AbstractRouterLink, Object.assign({}, rest, {
    component: Button,
    use: use
  }));
}